import { DateTime } from 'luxon'
import { Logger, type ProgramUserData, sortTasksByPriorityDescending, type TaskData } from '@terros/common'
import { getTaskExpirationDate } from './util'

const logger = new Logger('sortTasks')
// logger.level = 'verbose'

export function sortTasks(tasks: TaskData[], programUser?: ProgramUserData): TaskData[] {
  return tasks.sort((a, b) => {
    logger.verbose('sorting', a.taskId, b.taskId)

    const byStatus = getStatusNumber(a, programUser) - getStatusNumber(b, programUser)
    logger.verbose('byStatus', byStatus)
    if (byStatus) return byStatus

    const byDueDate = getDueDateNumber(a, programUser) - getDueDateNumber(b, programUser)
    logger.verbose('byDueDate', byDueDate)
    if (byDueDate) return byDueDate

    return sortTasksByPriorityDescending(a, b)
  })
}

function getStatusNumber(task: TaskData, programUser?: ProgramUserData): number {
  if (task.status === 'Completed') return 5
  const expirationDate = getTaskExpirationDate(task, programUser)
  if (expirationDate && expirationDate.toMillis() < DateTime.now().toMillis()) return 4
  if (task.dueDate && task.dueDate < DateTime.now().toMillis()) return -1
  if (task.openSince && task.openSince > DateTime.now().toMillis()) return 3
  if (task.status === 'Submitted') return 2
  return 1
}

function getDueDateNumber(task: TaskData, programUser?: ProgramUserData): number {
  if (!task.dueDate) return Infinity
  const now = DateTime.now()
  if (task.dueDate < now.toMillis()) {
    const date = getTaskExpirationDate(task, programUser)
    return date?.diff(now).as('minutes') ?? 0
  }
  return DateTime.fromMillis(task.dueDate).diff(now).as('minutes')
}
